"use client";

import { cn } from "@/lib/utils";

export function formatToolName(rawType: string): string {
  return rawType
    .replace(/^tool-/, "")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function getToolDisplayName(toolType: string): string {
  return formatToolName(toolType);
}

export function ToolCallFallback({
  value,
  className,
}: {
  value: unknown;
  className?: string;
}) {
  const outputText =
    typeof value === "string" ? value : JSON.stringify(value, null, 2);

  return (
    <pre
      className={cn(
        "text-xs bg-muted/40 rounded-md py-3 overflow-x-auto",
        className
      )}
    >
      {outputText}
    </pre>
  );
}
